import open from "webmodals/open";
import controller from "emun.cart/cart-item-additional-info.controller";
import templateUrl from "emun.cart/cart-item-additional-info.htm";

export default ({
  size = "md",
  backdrop = "static",
  placement = "center",
  preventAutoHeight = true,
  cartItem = {},
  product = cartItem.product,
  allowPriceOverride = false,
  title = `Additional Info ${cartItem.productId}`
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    resolve: {
      preventAutoHeight: () => preventAutoHeight,
      title: () => title,
      cartItem: () => cartItem,
      product: () => product,
      allowPriceOverride: () => allowPriceOverride
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;
